import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { getCookie } from '../../utils/getCookies'; // Adjust the path as necessary
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

  showSidebarMobile: boolean = false;
  @Input() is_from_ad: boolean = false;

  constructor(private router: Router) {}

  navigateToHome() {
    this.router.navigate(['/dashboard/company']);
  }

  isActive(path: string): boolean {
    let actualPath = this.router.url;
    return actualPath.includes(path);
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
  }

  canSeeDeepCV(): boolean {
    const canSeeDeepCV = getCookie('can_see_deep_cv');
    return canSeeDeepCV === 'true';
  }
}
